<template>
    <div>
        <header-section
            title="Resources and Tools"
            set-position="relative"
            :load-button="true"
            :create-button="true"
            set-width="100">
        </header-section>
        <div id="app" class="o-content ie p-resources-and-tools">
            <div class="o-content__mob-main-column">
                <router-link :to="'/resources-and-tools/documents'">
                    <h2>Documents</h2>
                </router-link>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    import HeaderSection from 'components/Header.vue';

    export default {
        components: {
            HeaderSection
        }
    }

</script>


// WEBPACK FOOTER //
// ResourcesAndTools.vue?62668ff6